import { JsonDecomposeProps } from './types';

export const decomposeJson = ({ src, sort, render }: JsonDecomposeProps) => {
  if (Array.isArray(src)) {
    const lastElement = src.length;
    return src.map((entry, index) => {
      return render({
        isLastElement: index + 1 === lastElement,
        label: `${index}`,
        value: entry,
      });
    });
  }

  const keys = Object.keys(src);
  const lastElement = keys.length;

  if (sort) {
    keys.sort();
  }

  return keys.map((key, index) =>
    render({
      isLastElement: index + 1 === lastElement,
      label: key,
      value: src[key],
    }),
  );
};
